<template>
  <v-fade-transition mode="out-in">
    <router-view />
  </v-fade-transition>
</template>

<script>
// Styles
import "@/styles/overrides.sass";

export default {
  name: "App",
  metaInfo: {
    title: "Cargo",
    titleTemplate: "Cargo",
    htmlAttrs: { lang: "en" },
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" }
    ]
  }
};
</script>

<style lang="css">
.w-100 {
  width: 100%;
}

/* .v-text-field input {
  font-size: 0.9em !important;
  text-transform: capitalize;
}
.v-text-field label {
  font-size: 0.9em !important;
}
.v-text-field button {
  font-size: 0.9em !important;
} */

/* .v-toolbar__content {
  height: 40px !important;
} */

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

#settings-wrapper {
  display: none;
}

::-webkit-scrollbar {
  height: 5px;
  width: 5px;
}

::-webkit-scrollbar-track {
  background-color: #e4e4e4;
  border-radius: 100px;
}

::-webkit-scrollbar-thumb {
  background-color: #b9b9b9;
  border-radius: 100px;
}

@media print {
  body * {
    visibility: hidden;
  }

  .v-main {
    padding: 0 !important;
  }

  #section-print,
  #section-print * {
    visibility: visible;
  }

  #section-print {
    position: relative;
    z-index: 1000;
  }

  #default-app-bar {
    display: none !important;
  }

  .v-input {
    display: none !important;
  }

  .v-main {
    padding-top: 0 !important;
  }

  .remove-print {
    display: none !important;
  }

  .v-bar--underline {
    display: none !important;
  }
}

/* Ensure modals are always above sidebar and other UI */
.v-dialog__content {
  z-index: 2200 !important;
}

.v-overlay__scrim {
  z-index: 2199 !important;
}
</style>
